import { Component, OnInit, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { catchError, of, tap } from 'rxjs';
import { Tc, TcPerfilUsuarioEnum, EnumSiNoTodos, TcExpanded } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { SolicitudViewModel } from '../../solicitudes/datosbasicos/datosbasicos.types';
import { SolicitudItemResultsViewModel, SolicitudItemViewModel, FilterSearchingSolicitudViewModel } from './buscador-solicitud.types';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { BuscadorSolicitudService } from './buscador-solicitud.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTcTipoSolicitud } from '../../solicitudes/types/enum';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';
import { HttpParams } from '@angular/common/http';
import { Table } from 'primeng/table';
import { LaboratorioService } from '../../solicitudes/laboratorio/laboratorio.service';

@Component({
    selector: 'app-buscador-solicitud-list',
    templateUrl: './buscador-solicitud-list.component.html',
    styleUrls: ['./buscador-solicitud-list.component.scss'],
})
export class BuscadorSolicitudListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultSolicitudes: SolicitudItemResultsViewModel;
    listPais: Tc[];
    listTipoSolicitud: TcExpanded[];
    listProvincias: Tc[];
    listPuntoInspeccion: Tc[] = [];
    listEstado: Tc[];
    listTipoAsignacion: Tc[];
    listEstadoChedPP: Tc[];
    listResultadoEnvioMuestrasLaboratorio: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    public isCollapsed = false;
    paisEspania = 0;

    EnabledCloned = false;

    habilitarNueva = true;
    visibilitySpinner = false;

    solicitudTipoNormal = EnumIdsTcTipoSolicitud.ID_NORMAL;
    solicitudTipoTraslado = EnumIdsTcTipoSolicitud.ID_TRASLADO;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected navMenuService: NavMenuService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        protected configurationService: ConfigurationService,
        private buscadorsolicitudService: BuscadorSolicitudService,
        private laboratorioService: LaboratorioService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultSolicitudes = new SolicitudItemResultsViewModel();
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.habilitarNueva = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_SOLICITUD).Visible;

        this.configurationService.getValue('Solicitud:EnabledCloned').subscribe(result => {
            this.EnabledCloned = JSON.parse(result);
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'RefSolicitante', header: 'Ref. Solicitante' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            { field: 'HoraEnvio', header: 'Hora' }, // | date:'dd/MM/yyyy'
            //{ field: 'NombreTipoSolicitudComplete', header: 'Tipo' },
            //{ field: 'DescripcionEstadoSolicitud', header: 'Estado' },
            { field: 'RazonSocial', header: 'Solicitante' },
            //{ field: 'NombreProvincia', header: 'Provincia' },
            { field: 'NombrePuntoInspeccion', header: 'Punto Inspección' },
            //{ field: 'Nregistro', header: 'Nº Registro ' },
            { field: 'NombreCompletoInspector', header: 'Inspector' },
            { field: 'NombreImportador', header: 'Importador' },
            { field: 'Exportador', header: 'Exportador' },
            { field: 'NombrePaisOrigen', header: 'País Origen' },
            { field: 'Ubicacion', header: 'Ubicación PIF' },
            { field: 'FechaInspeccion', header: 'Fecha Inspección' },
            { field: 'HoraInspeccion', header: 'Hora Inspección' },
            { field: 'Mrn', header: 'MRN' },
            //{ field: 'IsPredua', header: 'Pre DUA' },
            //{ field: 'EsPrevia', header: 'Previa' },
            { field: 'FormatoSolicitud', header: 'Formato' },
            { field: 'CodigoTraces', header: 'Código Traces' },
            { field: 'FechaFinalizacion', header: 'Fecha Decisión' },
            { field: 'FechaLlegada', header: 'Fecha/Hora Llegada' },
            //{ field: 'IdTipoClonacion', header: 'Tipo Clonación' },
            { field: 'IdEstado', header: 'IdEstado', display: 'none' },
            {
                field: 'IdEstadoChedPp',
                header: 'IdEstadoChedPp',
                display: 'none',
            },
            {
                field: 'IdResultadoEnvioMuestrasLaboratorio',
                header: 'IdResultadoEnvioMuestrasLaboratorio',
                display: 'none',
            },
            { field: 'DocumentalRealizada', header: 'Documental Realizada' },
            { field: 'IdentidadRealizada', header: 'Identidad Realizada' },
            { field: 'FisicaRealizada', header: 'Fisica Realizada' },
        ];

        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getTipoSolicitudActivos().subscribe(res => {
            this.listTipoSolicitud = res;
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        let params = new HttpParams();
        if (this.buscadorsolicitudService.currentFilterSolicitud.IdProvincia != null) {
            params = params.append('id', this.buscadorsolicitudService.currentFilterSolicitud.IdProvincia!.toString());
            params = params.append('esimportacion', 'true');
            this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
                this.listPuntoInspeccion = res;
            });
        }

        this.globalService.getEstadoSolicitud().subscribe(res => {
            this.listEstado = res;
        });
        this.globalService.getTipoAsignacion(false).subscribe(res => {
            this.listTipoAsignacion = res;
        });
        this.globalService.getEstadoChedPP().subscribe(res => {
            this.listEstadoChedPP = res;
        });

        this.laboratorioService.getResultadosMuestraLaboratorio().subscribe(res => {
            this.listResultadoEnvioMuestrasLaboratorio = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            Codigo: '',
            IdEstadoSolicitud: null,
            IdEstadoChedPp: null,
            IdPais: null,
            IdTipoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            NombreImportador: '',
            NRegistro: '',
            RazonSocial: '',
            IsPredua: EnumSiNoTodos.TODOS,
            Mrn: '',
            EsPrevia: EnumSiNoTodos.TODOS,
            EsPapel: EnumSiNoTodos.TODOS,
            EsReImportacion: EnumSiNoTodos.TODOS,
            RefSolicitante: '',
            CodigoTraces: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            Asignada: EnumSiNoTodos.TODOS,
            IdResultadoEnvioMuestrasLaboratorio: null,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            FinalizaTraslado: EnumSiNoTodos.TODOS,
            TrasladoNOFinalizado: EnumSiNoTodos.TODOS,
            DocumentalRealizada: EnumSiNoTodos.TODOS,
            ProcedenciaUe: EnumSiNoTodos.TODOS,
            Exportador: '',
        });

        const config = this.getConfig();
        this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadLastSearch();
    }

    private loadLastSearch(): void {
        if (
            this.buscadorsolicitudService.currentFilterSolicitud.FechaDesde == null ||
            this.buscadorsolicitudService.currentFilterSolicitud.FechaHasta == null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdEstadoSolicitud != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdEstadoChedPp != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdPais != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdProvincia != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdPuntoInspeccion != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdTipoSolicitud != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.Codigo != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.Mrn != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.IsPredua != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.EsPrevia != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.EsPapel != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.EsReImportacion != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.Asignada != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.NombreImportador != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.Exportador != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.NRegistro != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.RazonSocial != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.RefSolicitante != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.CodigoTraces != '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.IdResultadoEnvioMuestrasLaboratorio != null ||
            this.buscadorsolicitudService.currentFilterSolicitud.TieneEnvioDeMuestras != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.FinalizaTraslado != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.TrasladoNOFinalizado != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.FechaDesde?.toString() != this.firstDayMonth.toString() ||
            this.buscadorsolicitudService.currentFilterSolicitud.FechaHasta?.toString() != this.lastDayMonth.toString() ||
            (this.buscadorsolicitudService.currentFilterSolicitud.PageNumber !== 0 &&
                this.buscadorsolicitudService.currentFilterSolicitud.PageNumber !== undefined) ||
            this.buscadorsolicitudService.currentFilterSolicitud.OrderBy !== '' ||
            this.buscadorsolicitudService.currentFilterSolicitud.DocumentalRealizada != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudService.currentFilterSolicitud.ProcedenciaUe != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                IdEstadoSolicitud: this.buscadorsolicitudService.currentFilterSolicitud.IdEstadoSolicitud,
                IdEstadoChedPp: this.buscadorsolicitudService.currentFilterSolicitud.IdEstadoChedPp,
                IdPais: this.buscadorsolicitudService.currentFilterSolicitud.IdPais,
                IdProvincia: this.buscadorsolicitudService.currentFilterSolicitud.IdProvincia,
                IdPuntoInspeccion: this.buscadorsolicitudService.currentFilterSolicitud.IdPuntoInspeccion,
                IdTipoSolicitud: this.buscadorsolicitudService.currentFilterSolicitud.IdTipoSolicitud,
                Codigo: this.buscadorsolicitudService.currentFilterSolicitud.Codigo,
                Mrn: this.buscadorsolicitudService.currentFilterSolicitud.Mrn,
                IsPredua: this.buscadorsolicitudService.currentFilterSolicitud.IsPredua,
                EsPrevia: this.buscadorsolicitudService.currentFilterSolicitud.EsPrevia,
                EsPapel: this.buscadorsolicitudService.currentFilterSolicitud.EsPapel,
                EsReImportacion: this.buscadorsolicitudService.currentFilterSolicitud.EsReImportacion,
                Asignada: this.buscadorsolicitudService.currentFilterSolicitud.Asignada,
                NombreImportador: this.buscadorsolicitudService.currentFilterSolicitud.NombreImportador,
                Exportador: this.buscadorsolicitudService.currentFilterSolicitud.Exportador,
                NRegistro: this.buscadorsolicitudService.currentFilterSolicitud.NRegistro,
                RazonSocial: this.buscadorsolicitudService.currentFilterSolicitud.RazonSocial,
                RefSolicitante: this.buscadorsolicitudService.currentFilterSolicitud.RefSolicitante,
                CodigoTraces: this.buscadorsolicitudService.currentFilterSolicitud.CodigoTraces,
                IdResultadoEnvioMuestrasLaboratorio: this.buscadorsolicitudService.currentFilterSolicitud.IdResultadoEnvioMuestrasLaboratorio,
                TieneEnvioDeMuestras: this.buscadorsolicitudService.currentFilterSolicitud.TieneEnvioDeMuestras,
                FinalizaTraslado: this.buscadorsolicitudService.currentFilterSolicitud.FinalizaTraslado,
                TrasladoNOFinalizado: this.buscadorsolicitudService.currentFilterSolicitud.TrasladoNOFinalizado,
                FechaDesde: this.buscadorsolicitudService.currentFilterSolicitud.FechaDesde,
                FechaHasta: this.buscadorsolicitudService.currentFilterSolicitud.FechaHasta,
                DocumentalRealizada: this.buscadorsolicitudService.currentFilterSolicitud.DocumentalRealizada,
                ProcedenciaUe: this.buscadorsolicitudService.currentFilterSolicitud.ProcedenciaUe,
            });

            this.onSearchButton(
                this.buscadorsolicitudService.currentFilterSolicitud.PageNumber,
                this.buscadorsolicitudService.currentFilterSolicitud.Asc,
                this.buscadorsolicitudService.currentFilterSolicitud.OrderBy,
            );
        }
    }

    onSearchButton(pageNumber = 0, asc = 0, orderBy = ''): void {
        this.search(pageNumber, asc, orderBy);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    private createModel(): FilterSearchingSolicitudViewModel {
        const model: FilterSearchingSolicitudViewModel = new FilterSearchingSolicitudViewModel();

        model.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        model.IdEstadoChedPp = this.form.value.IdEstadoChedPp;
        model.IdPais = this.form.value.IdPais;
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.IdTipoSolicitud = this.form.value.IdTipoSolicitud;
        //model.IdTipoAsignacion = this.form.value.IdTipoAsignacion;
        model.Codigo = this.form.value.Codigo;
        model.Mrn = this.form.value.Mrn;
        model.IsPredua = this.form.value.IsPredua;
        model.EsPrevia = this.form.value.EsPrevia;
        model.EsPapel = this.form.value.EsPapel;
        model.EsReImportacion = this.form.value.EsReImportacion;
        model.Asignada = this.form.value.Asignada;
        model.NombreImportador = this.form.value.NombreImportador;
        model.NRegistro = this.form.value.NRegistro;
        model.CodigoTraces = this.form.value.CodigoTraces;
        model.Mrn = this.form.value.Mrn;
        model.RazonSocial = this.form.value.RazonSocial;
        model.NRegistro = this.form.value.NRegistro;
        model.RefSolicitante = this.form.value.RefSolicitante;
        model.IdResultadoEnvioMuestrasLaboratorio = this.form.value.IdResultadoEnvioMuestrasLaboratorio;
        model.TieneEnvioDeMuestras = this.form.value.TieneEnvioDeMuestras;
        model.FinalizaTraslado = this.form.value.FinalizaTraslado;
        model.TrasladoNOFinalizado = this.form.value.TrasladoNOFinalizado;
        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta;

        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = this.isInspector;
        model.EsCoordinador = this.isCoordinador;
        model.EsSolicitante = this.isSolicitante;
        model.EsGrabador = this.isGrabador;
        model.EsConsultas = this.isConsultas;
        model.EsConsultasySolicitante = this.isConsultas && this.isSolicitante;
        model.Exportador = this.form.value.Exportador;
        model.EsConsultasyLaboratorio = this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);

        model.DocumentalRealizada = this.form.value.DocumentalRealizada;
        model.ProcedenciaUe = this.form.value.ProcedenciaUe;

        return model;
    }

    private search(pageNumber: number, asc = 0, orderBy = ''): void {
        const model: FilterSearchingSolicitudViewModel = this.createModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaHasta != null) {
            model.FechaHasta.setHours(23);
            model.FechaHasta.setMinutes(59);
            model.FechaHasta.setSeconds(59);
        }
        this.loading = true;

        this.buscadorsolicitudService
            .postSolicitudPagedByFilter(model)
            .pipe(
                tap(result => {
                    this.resultSolicitudes = { ...result };
                    setTimeout(() => {
                        if (this.turboTable) {
                            this.turboTable.first = pageNumber * (this.resultSolicitudes?.PageSize || 1);
                        }
                    }, 100);
                    this.loading = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form?.disable();
                    this.loading = false;
                    return of(null);
                }),
            )
            .subscribe();

        this.buscadorsolicitudService.currentFilterSolicitud = model;
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Codigo: '',
            IdEstadoSolicitud: null,
            IdEstadoChedPp: null,
            IdPais: null,
            IdTipoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            NombreImportador: '',
            NRegistro: '',
            RazonSocial: '',
            Mrn: '',
            IsPredua: EnumSiNoTodos.TODOS,
            EsPrevia: EnumSiNoTodos.TODOS,
            EsPapel: EnumSiNoTodos.TODOS,
            EsReImportacion: EnumSiNoTodos.TODOS,
            Asignada: EnumSiNoTodos.TODOS,
            RefSolicitante: '',
            CodigoTraces: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdResultadoEnvioMuestrasLaboratorio: null,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            FinalizaTraslado: EnumSiNoTodos.TODOS,
            TrasladoNOFinalizado: EnumSiNoTodos.TODOS,
            DocumentalRealizada: EnumSiNoTodos.TODOS,
            ProcedenciaUe: EnumSiNoTodos.TODOS,
            Exportador: '',
        });

        this.isCollapsed = false;
        this.searchingButton = false;

        this.resultSolicitudes = new SolicitudItemResultsViewModel();

        this.buscadorsolicitudService.resetFilter();
    }

    onSelectPais(): void {
        // NO-OP
    }

    onSelectProvincia(): void {
        const idProvincia = this.form.value.IdProvincia;

        let params = new HttpParams();
        params = params.append('id', idProvincia?.toString() || null);
        params = params.append('esimportacion', 'true');

        this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.form.patchValue({
            IdPuntoInspeccion: null,
        });
    }

    onSelectEstado(): void {
        //Si es borrador, limpiamos las fechas
        if (this.form.value.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_BORRADOR) {
            this.form.patchValue({
                FechaDesde: null,
                FechaHasta: null,
            });
        } else {
            //Todo:agaro. Quitamos que se cambien las fechas si el estado es distinto de borrador, para no alterar los filtros.
            //if (this.form.value.FechaDesde == null || this.form.value.FechaHasta == null) {
            //    this.form.patchValue({
            //        FechaDesde: this.firstDayMonth,
            //        FechaHasta: this.lastDayMonth
            //    });
            //}
        }
    }

    checkDelete(rowData: SolicitudItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_SOLICITUD, rowData.IdEstado).Visible && rowData.EsVisibleEdicion;
    }

    checkClone(rowData: SolicitudItemViewModel): boolean {
        //Todo:agaro. 10062020. Grabador solo clonables las suyas, sobra la validación con inspector.
        if (this.isGrabador) {
            // && this.EsInspector) {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.CLONACION_SOLICITUD, undefined, rowData.IdTipoSolicitud, rowData.IdSubTipoSolicitud)
                    .Visible &&
                rowData.EsVisibleEdicion &&
                rowData.IdEstado != EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE
            );
        } else {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.CLONACION_SOLICITUD, undefined, rowData.IdTipoSolicitud, rowData.IdSubTipoSolicitud)
                    .Visible && rowData.IdEstado != EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE
            );
        }
    }

    onEdit(item: SolicitudViewModel): void {
        this.router.navigate(['/importacion/solicitud/datosbasicos', item.Id]);
    }

    onDelete(item: SolicitudViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de eliminar la solicitud?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.buscadorsolicitudService.deleteSolicitud(item.Id).subscribe(() => {
                    this.addSuccessMessage('Solicitud eliminada correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    onClone(item: SolicitudItemViewModel): void {
        let params = new HttpParams();

        params = params.append('id', item.Id.toString());

        //Diferenciamos por tipo de Solicitud, para clonar como NO previas con los incluidos en el IF y si es otro ejecutar el else escogiendo
        if (
            item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_CANARIAS ||
            item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSBORDO ||
            item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO ||
            item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO
        ) {
            params = params.append('esprevia', false.toString());
            params = params.append('finalizaTraslado', false.toString());
            this.buscadorsolicitudService.cloneSolicitud(params).subscribe({
                next: res => {
                    this.addSuccessMessage('Solicitud clonada correctamente');
                    const idSolicitud = res;
                    this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
                },
                error: error => {
                    this.catchServerError(error);
                },
            });
        } else {
            this.confirmationService.confirm({
                message: 'Esta solicitud se creó como "' + item.NombreTipoSolicitudComplete + '". ¿Cómo desea clonar la solicitud?',
                acceptLabel: 'Previa',
                rejectLabel: 'No Previa',
                rejectButtonStyleClass: 'customReject',
                accept: () => {
                    params = params.append('esprevia', true.toString());
                    params = params.append('finalizaTraslado', false.toString());
                    this.buscadorsolicitudService.cloneSolicitud(params).subscribe({
                        next: res => {
                            this.addSuccessMessage('Solicitud clonada correctamente');
                            const idSolicitud = res;
                            this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
                        },
                        error: error => {
                            this.catchServerError(error);
                        },
                    });
                },
                reject: () => {
                    //rdlf: diferencio entre clicks 'No Previa' y cerrar ventana, para llamar al service Clonar o no.
                    const clickConfirm = event?.currentTarget as HTMLElement;
                    if (clickConfirm.innerText == 'No Previa') {
                        params = params.append('esprevia', false.toString());
                        this.buscadorsolicitudService.cloneSolicitud(params).subscribe({
                            next: res => {
                                this.addSuccessMessage('Solicitud clonada correctamente');
                                const idSolicitud = res;
                                this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
                            },
                            error: error => {
                                this.catchServerError(error);
                            },
                        });
                    }
                },
            });
        }
    }

    onAdd(): void {
        this.navMenuService.currentSolicitudImportacion = new SolicitudViewModel();
        this.router.navigate(['/importacion/solicitud/tipossolicitudes']);
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;
        this.buscadorsolicitudService.export(this.createModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultSolicitudes?.ResultList ? this.resultSolicitudes?.ResultList?.length > 0 : false;
    }
}
